import { normalizeMenuUrl } from "./menuUrl";
import { resolveContentCategory } from "./searchPageLabel";
import { isNumericRecordId } from "./searchNewsUrl";

function pickRawUrl(hit) {
  const candidates = [hit.url, hit.path, hit.link, hit.slug];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return "";
}

function pickRecordId(hit) {
  if (isNumericRecordId(hit.id)) {
    return hit.id;
  }
  return null;
}

/**
 * Resolve a navigable URL for a search hit, with content-type fallbacks.
 */
export function resolveSearchHitUrl(hit, contentType) {
  const normalized = normalizeMenuUrl(pickRawUrl(hit));
  if (normalized) return normalized;

  const category = resolveContentCategory(contentType);
  const id = pickRecordId(hit);

  switch (category) {
    case "news":
      return id ? `/news/${id}` : "/news";
    case "download":
      return "/downloads";
    case "support":
      return "/resources";
    default:
      return null;
  }
}
